// src/components/compliance/modals/ActiveFindingsModal.jsx

import React from "react";
import ModalShell from "./shared/ModalShell";
import MetricTile from "./shared/MetricTile";
import ModalSection from "./shared/ModalSection";

const metricGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(4, minmax(0, 1fr))",
  gap: 16,
};

export default function ActiveFindingsModal({
  open,
  framework,
  activeFindingRows = [],
  activeFindingCount = 0,
  loadedActiveRiskQueueCount = 0,
  highSeverityCount = 0,
  noTaskCount = 0,
  renderActiveFindingRow,
  onClose,
}) {
  if (!open) return null;

  const rows = Array.isArray(activeFindingRows) ? activeFindingRows : [];
  const shownCount = rows.length;

  return (
    <ModalShell
      open={open}
      ariaLabel="Active findings"
      className="oasys-active-findings-modal"
      eyebrow="OASYS · ACTIVE FINDINGS"
      title="Active Findings"
      subtitle="Review unresolved findings driving the current posture score. Open Review / Manage, Fix Plan, Guidance, or Drift without expanding the main posture page."
      onClose={onClose}
      maxWidth="1120px"
      accentBorder="rgba(74, 222, 128, 0.45)"
    >
      <div style={metricGridStyle}>
        <MetricTile
          label="Unresolved"
          value={activeFindingCount}
          sub={`${framework} active findings`}
          color={activeFindingCount > 0 ? "#f87171" : "#34d399"}
        />
        <MetricTile label="Shown" value={shownCount} sub={`of ${loadedActiveRiskQueueCount} loaded`} color="#60a5fa" />
        <MetricTile
          label="High Severity"
          value={highSeverityCount}
          sub="priority findings"
          color={highSeverityCount > 0 ? "#f87171" : "#34d399"}
        />
        <MetricTile
          label="No Task"
          value={noTaskCount}
          sub="needs tracking"
          color={noTaskCount > 0 ? "#fbbf24" : "#34d399"}
        />
      </div>

      <ModalSection
        title="Active Finding Activity"
        description="Showing the loaded active findings for this framework. Top Risks are included first when available."
        badge={`${shownCount} shown`}
        badgeTone={shownCount > 0 ? "warn" : "ok"}
      >
        {shownCount === 0 ? (
          <div className="muted" style={{ padding: 14 }}>
            No active findings are loaded for this framework.
          </div>
        ) : (
          rows.map((risk, idx) => renderActiveFindingRow(risk, idx, "active"))
        )}
      </ModalSection>
    </ModalShell>
  );
}
